export default "__VITE_ASSET__DrtXpjfU__"